<template>
	<div>
		<v-data-table
			ref="dataTable"
			:loading="loading"
			:items="items"
			:headers="headers"
			dense
			disable-pagination
			hide-default-footer
			multi-sort
		>
			<template #item.link="{item}">
				<imot-details-link
					target-blank
					:utility="utility"
					:session="session"
					:station="item.station_id"
				/>
			</template>
		</v-data-table>
		<div class="text-right mt-4">
			<export-csv color="primary" :headers="headers" :items="exportItems">
				<v-icon left>mdi-export</v-icon>
				CSV
			</export-csv>
		</div>
	</div>
</template>

<script>
import IModelMixin from "@/ittijs/IModelMixin";
import ExportCsv from "@/ittijs/components/export-csv";
import MountedMixin from "@/ittijs/MountedMixin";
import SDModel from "@/views/stations/ModelData";
import ImotDetailsLink from "@/ittijs/components/ImotDetailsLink.vue";

const sdmodel = new SDModel();

export default {
	components: {ImotDetailsLink, ExportCsv},
	mixins: [
		IModelMixin,
		MountedMixin,
	],
	props: [
		'utility',
		'session',
		'items',
		'fields', // extra headers
	],
	data(){
		return {
			loading: false,
		}
	},
	computed: {
		headers(){
			return [
				{text: "Станция", value: "station_N"},
				{text: "Адрес", value: "address"},
				...(Array.isArray(this.fields) && this.fields || [])
					.map(f => ({text: sdmodel.getLabel(f), value: f})),
				{text: "", value: "link", width: "1%", csv: false},
			];
		},
		exportItems(){
			if (!this.mounted) return [];
			return this.$refs.dataTable && this.$refs.dataTable.internalCurrentItems || [];
		},
	},
}
</script>